<template>
  <el-header
    class="main-header"
    height="60px"
  >
    <el-row
      type="flex"
      justify="space-between"
      align="bottom"
      class="main-header__row"
    >
      <el-col>
        <TabsNavigation />
      </el-col>
    </el-row>
  </el-header>
</template>

<script>
  import TabsNavigation from './TabsNavigation.vue';

  export default {
    name: 'MainHeader',
    components: {
      TabsNavigation,
    },
  };
</script>

<style lang="scss">
  .main-header {
    background-color: $--color-black-lighter;

    &__row {
      height: 100%;
    }
  }
</style>
